/* oxlint-disable jsx-a11y/no-autofocus -- Dialog opens directly into the API key name field. */
import type { ChangeEvent } from 'react';

import { Box, DialogActions, styled, TextField, Typography } from '@/shared/ui';

import { spacing } from '@/config/ui';
import { DialogButton } from '@/shared/ui/overlays/Modal';

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& label.Mui-focused': {
    color: theme.palette.gx.text
  },
  '& label.Mui-error': { color: theme.palette.gx.text },
  '& div.MuiInput-underline::after': {
    borderBottom: `2px solid ${theme.palette.gx.text}`
  }
}));

type PreGenerationBodyProps = {
  handleClose: () => void;
  handleChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  apiKeyName: string;
  onGenerate: () => void;
  error: string;
  loading: boolean;
};

const PreGenerationBody = ({
  handleClose,
  handleChange,
  apiKeyName,
  onGenerate,
  error,
  loading
}: PreGenerationBodyProps) => (
  <>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: spacing[2] }}>
      <Typography variant='body2'>Name</Typography>
      <StyledTextField
        autoFocus
        autoComplete='off'
        disabled={loading}
        error={!!error}
        helperText={error}
        id='key-label'
        slotProps={{ htmlInput: { maxLength: 60 } }}
        value={apiKeyName}
        variant='standard'
        onChange={handleChange}
      />
    </Box>
    <DialogActions sx={{ mt: spacing[2], gap: spacing[1] }}>
      <DialogButton
        variant='outlined'
        onClick={handleClose}
      >
        Cancel
      </DialogButton>
      <DialogButton
        disabled={!apiKeyName.length || loading || Boolean(error.length)}
        variant='contained'
        onClick={onGenerate}
      >
        Generate
      </DialogButton>
    </DialogActions>
  </>
);

export default PreGenerationBody;
